// extracted by mini-css-extract-plugin
export default {"bodyContainer":"PracticeSearch_bodyContainer__ILQMl","practiceCount":"PracticeSearch_practiceCount__YFSdN"};